import apiService from './api';

const DEFAULT_ROLE = 'user';
const NOT_AVAILABLE = 'Not available';

/**
 * Extract role-related details from user object
 */
const extractRoleDetails = (user) => {
  let userRoles = DEFAULT_ROLE;
  let jobTitle = NOT_AVAILABLE;
  let officeLocation = NOT_AVAILABLE;

  if (Array.isArray(user.role) && user.role.length > 0) {
    userRoles = user.role
      .map((roleObj) => roleObj.RoleName || DEFAULT_ROLE)
      .join(', ');

    const firstRole = user.role[0];
    jobTitle = firstRole.JobTitle || jobTitle;
    officeLocation = firstRole.OfficeLocation || officeLocation;
  }

  return { userRoles, jobTitle, officeLocation };
};

/**
 * Handle unauthorized errors
 */
const handleUnauthorizedError = (error) => {
  if (error instanceof Error && error.message.includes('401')) {
    console.log('🔐 Unauthorized - clearing tokens and redirecting to login');
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('refresh_token');
    sessionStorage.removeItem('user_details');
    window.location.href = '/login';
  }
};

const FetchUserDetails = async () => {
  try {
    console.log('🔄 Fetching user details from API...');
    const data = await apiService.getUserDetails();
    console.log('📊 API Response:', data);

    if (data.status !== 'success' || !data.user) {
      console.error('❌ Invalid response format:', data);
      return false;
    }

    console.log('👤 User data received:', data.user);

    const { userRoles, jobTitle, officeLocation } = extractRoleDetails(data.user);

    console.log('🎭 User roles extracted:', userRoles);

    sessionStorage.setItem('user_name', data.user.name || NOT_AVAILABLE);
    sessionStorage.setItem('user_emailId', data.user.email || NOT_AVAILABLE);
    sessionStorage.setItem('user_id', data.user.email || '');
    sessionStorage.setItem('image_url', data.user.profile_img_url || '');
    sessionStorage.setItem('user_role', userRoles);
    sessionStorage.setItem('user_department', data.user.department || NOT_AVAILABLE);
    sessionStorage.setItem('job_title', jobTitle);
    sessionStorage.setItem('office_location', officeLocation);
    sessionStorage.setItem('manager_name', data.user.manager_name || '');
    sessionStorage.setItem('manager_email', data.user.manager_email || '');
    sessionStorage.setItem('access_role', data.user.access_role || DEFAULT_ROLE);
    sessionStorage.setItem('mobile_phone', data.user.mobile_phone || '');
    sessionStorage.setItem('user_role_data', JSON.stringify(data.user.role || []));
    sessionStorage.setItem('user_roles', JSON.stringify(data.user.roles || []));
    sessionStorage.setItem(
      'user_roles_csv',
      (data.user.roles || []).join(',')
    );

    console.log('  - access_role:', sessionStorage.getItem('access_role'));
    console.log('  - mobile_phone:', sessionStorage.getItem('mobile_phone'));
    console.log('  - user_role_data:', sessionStorage.getItem('user_role_data'));

    return true;
  } catch (error) {
    console.error('❌ Error fetching user data:', error);
    handleUnauthorizedError(error);
    return false;
  }
};

export default FetchUserDetails;
